module.exports = __webpack_public_path__ + "static/media/vnda9.096a0f79.png";